import { useSelector } from 'react-redux';
import { Responsive, UIHeading3 } from '@cian/ui-kit';
import { OffersStats, OffersStatsLayout } from '../../components/OffersStats';
import { fromDeveloperRoomsSelector } from '../../selectors/newbuilding';
import { OffersStatsItemContainer } from './OffersStatsItem';

export const OffersStatsContainer = () => {
  const fromDeveloperRooms = useSelector(fromDeveloperRoomsSelector);

  if (!fromDeveloperRooms?.length) {
    return null;
  }

  return (
    <OffersStatsLayout>
      <Responsive phone tablet>
        <UIHeading3>Все квартиры в ЖК</UIHeading3>
      </Responsive>
      <OffersStats>
        {fromDeveloperRooms.map(offer => {
          return (
            <OffersStatsItemContainer
              key={offer.roomTypeDisplay}
              roomType={offer.roomTypeDisplay}
              price2Range={offer.price2Range}
              totalAreaMinDisplay={offer.totalAreaMinDisplay}
              fromDeveloperPropsCount={offer.fromDeveloperPropsCount}
              offersUrl={offer.offersUrl}
            />
          );
        })}
      </OffersStats>
    </OffersStatsLayout>
  );
};
